// Mock data for form submissions
export const mockFormSubmit = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (mock):', formData);
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
      submissions.push({
        ...formData,
        id: Date.now(),
        submittedAt: new Date().toISOString()
      });
      localStorage.setItem('formSubmissions', JSON.stringify(submissions));
      resolve({ success: true, message: 'Thank you! We will contact you soon.' });
    }, 1000);
  });
};

// Mock data for contact info
export const contactInfo = {
  businessName: 'TradeMark Registry',
  email: 'info@trademarknameforbusiness.com',
  phone: '+1 (123) 123-4567',
  address: '724 S Spring St, Los Angeles, CA 90014'
};

// Trust signals data
export const trustSignals = [
  { value: '1000+', label: 'Trademarks Filed' },
  { value: '15+', label: 'Years Experience' },
  { value: '98%', label: 'Success Rate' },
  { value: '500+', label: 'Happy Clients' }
];

// Industries served
export const industries = [
  'Technology & Software',
  'E-commerce & Retail',
  'Food & Beverage',
  'Healthcare & Medical',
  'Fashion & Apparel',
  'Entertainment & Media',
  'Professional Services',
  'Manufacturing'
];
